module.exports = __webpack_public_path__ + "img/panorama_wide_angle.caf25579.svg";